document.addEventListener("click", async function(e) {

  const atcBtn = e.target.closest(".custom-product-card-atc");

  if (!atcBtn) return;

  e.preventDefault();
  e.stopPropagation();

  const originalText = atcBtn.innerText;

  atcBtn.disabled = true;
  atcBtn.innerText = "Adding...";

  try {

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        id: atcBtn.dataset.variantId,
        quantity: 1
      })
    });

    if (!response.ok) {
      throw new Error("Add to cart failed");
    }

    atcBtn.innerText = "Added ✓";

    const cartButton =
      document.querySelector('[data-cart-toggle]') ||
      document.querySelector('.site-nav__link--icon') ||
      document.querySelector('[href="/cart"]');

    if (cartButton) {
      cartButton.click();
    }

    setTimeout(() => {
      atcBtn.disabled = false;
      atcBtn.innerText = originalText;
    }, 1500);

  } catch(err) {

    console.error(err);

    atcBtn.disabled = false;
    atcBtn.innerText = originalText;
  }

});

// document.addEventListener("click", function(e){

//   const btn = e.target.closest(".custom-product-card-quickshop");

//   if (!btn) return;

//   e.preventDefault();

//   const productCard = btn.closest(".grid-product");

//   if (!productCard) return;

//   const quickShopBtn = productCard.querySelector(".quick-product__btn");

//   if (quickShopBtn) {
//     quickShopBtn.click();
//   }

// });
document.addEventListener("click", function(e){

  const btn = e.target.closest(".custom-product-card-quickview");

  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const productCard = btn.closest(".grid-product");

  if (!productCard) return;

  const quickShopBtn = productCard.querySelector(
    '[class*="js-modal-open-quick-modal"]'
  );

  if (quickShopBtn) {
    quickShopBtn.click();
  } else {
    console.log("Quick Shop button not found");
  }

});